import styled from 'styled-components'

export const SimulationResultsContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  font-family: Ubuntu;

  .DFaccordionBox {
    text-align: left !important;
  }
`

export const QuotationContainer = styled.div`
  margin-bottom: 150px;

  > div {
    padding-top: 0;
  }
`

export const SimulationDataContainer = styled.div`
  display: block;
  width: 100%;
  margin-bottom: 32px;

  .loader-wrapper {
    z-index: 999;
  }

  .container {
    display: flex;
    /* align-items: flex-start; */
    align-items: center;
    gap: 32px;

    .row:first-child {
      > div {
        margin-bottom: 0;
      }
    }

    .row {
      width: 50%;

      > div {
        margin-top: 0;

        .DFcontainer:first-child {
          padding-top: 4px;
        }
      }
    }
  }
`

export const SimulationDataElements = styled.div``
